const initialState = {
    loadingReport: false,
    errorReport: null,
    report: null
};

export default function getReportes(state=initialState, action){
    switch (action.type){
        case 'DOWNLOAD_FILE_SUCCESS':
            return {...state, loadingReport: false, report: action.data, errorReport: null};
        case 'DOWNLOAD_FILE_FAILED':
            return {...state, loadingReport: false, report: null, errorReport: 'No ha sido posible generar el archivo. Inténtelo de nuevo.'};
        case 'DOWNLOAD_FILE_LOADING':
            return {...state, loadingReport: true, report: null, errorReport: null};
        default:
            return state;
    }
}